import {history} from '../store/index';
import {store} from '../../NextApp';
import {generateQueryString} from "../../util/Api";
import {
  CREATE_ASSET_CLASSIFICATION_SUCCESS,
  FETCH_ASSET_CLASSIFICATION_SUCCESS,
  GET_ASSET_CLASSIFICATION_SUCCESS,
  SAVE_ASSET_CLASSIFICATION_QUERY
} from "../../constants/ActionTypes";
import axios from 'util/Api'
import {
  fetchError,
  fetchFilter,
  fetchStart,
  fetchSubElementFilter,
  fetchSuccess,
  fetchSuperMasterFilter
} from "./Common";
import {getUser} from "./Auth";
import {message} from "antd";
import {arrayToCSV, downloadCSV} from "../../util/methods";


export const getResourceSuccess = ({data, count}) => {
  return {
    type: GET_ASSET_CLASSIFICATION_SUCCESS,
    data,
    count
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_ASSET_CLASSIFICATION_QUERY,
    query
  };
};

export const createResourceSuccess = ({data}) => {
  return {
    type: CREATE_ASSET_CLASSIFICATION_SUCCESS,
    data
  };
};

export const fetchResourceSuccess = ({data}) => {
  return {
    type: FETCH_ASSET_CLASSIFICATION_SUCCESS,
    data
  };
};

export const getResource = () => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const {assetMake} = store.getState();
      const {query} = assetMake;
      const response = await axios.get(`/asset-classification?${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const {assetMake} = store.getState();
      const {query} = assetMake;
      const response = await axios.get(`/asset-classification/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns)
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const createResource = (payload, redirect = true, module, subMaster = false, superMaster = false) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      let formData = new FormData();
      formData.append('name', payload.name);
      if(payload.files && payload.files.file) {
        formData.append('files', payload.files.file);
      }

      const response = await axios.post(`/asset-classification`,  formData, {config: {headers: {'Content-Type': 'multipart/form-data'}}});
      if(response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      } else {
        dispatch(fetchSuccess());
        dispatch(createResourceSuccess({data: response.data}));
      }
      if(!redirect) {
        if(subMaster) {
          dispatch(fetchSubElementFilter(module));
        } else {
          if(superMaster) {
            dispatch(fetchSuperMasterFilter(module));
          } else {
            dispatch(fetchFilter(module));
          }
        }
      } else {
        history.push('/asset-classification');
        dispatch(getResource());
      }
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const updateResource = (payload, id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      let formData = new FormData();
      formData.append('name', payload.name);
      if(payload.files && payload.files.file) {
        formData.append('files', payload.files.file);
      }
      const response = await axios.put(`/asset-classification/${id}`,  formData, {config: {headers: {'Content-Type': 'multipart/form-data'}}});
      if(response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      }
      dispatch(fetchSuccess());
      dispatch(getUser());
      history.push('/asset-classification');
      dispatch(getResource());
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error.response.data.message));
    }
  }
};

export const fetchResource = (id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/asset-classification/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({data: response.data}));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const deleteResource = (id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.delete(`/common/asset-classification/${id}`);
      if(response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      }
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};
